<template>
  <svg class="svg-inline--fa fa-w-16" fill="none" viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M10 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM4 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0ZM16 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z" fill="currentColor" class="fill-030708"></path></svg>
</template>
<script setup lang="ts">
</script>